const PlayerOnPitchStats = {
  NONE: 'none',
  GOALS: 'goals',
  ASSISTS: 'assists',
  BOTH: 'both',
} as const;

export default PlayerOnPitchStats;
